/* eslint-disable react/prop-types */
import React from 'react'
import { useOutletContext } from 'react-router-dom'
import TemplateForm from '../../Forms/TemplateForm'
import Footer from './Footer'

export function TemplateSection() {
  const formRef = React.useRef(null)
  const { verificationListing } = useOutletContext()

  if (!verificationListing || !verificationListing.id) {
    return null
  }

  return (
    <div style={{ position: 'relative' }}>
      <TemplateForm innerRef={formRef} listing={verificationListing} isWizard={false} />
      <Footer label="Save" onSubmit={() => formRef.current.requestSubmit()} />
    </div>
  )
}

export default TemplateSection
